<template lang="pug">
  v-container
    v-row
      v-col
        h1 Mis imágenes
        v-fab-transition
          Agregar_imagen_boton( fab )
    v-row
      Imagen_item( cols='3'  v-for='imagen, i in registro' :key='i' @_seleccionar_imagen='val=>seleccionar_imagen(val)' :imagen='imagen' publicable)
            
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  data: ()=>({
    imagenes_dialog: false,
  }),
  methods: {
    seleccionar_imagen(imagen){
      this.$emit('seleccionar_imagen', imagen)
      this.imagenes_dialog = false
    },
  },
  computed:{
    ...mapGetters({
      registro: 'Imagenes/registro'
    })
  },
  components: {
    Agregar_imagen_boton: ()=>import('../contenido/componentes/agregar_imagen_boton'),
    Imagen_item: ()=>import('./componenes/imagen_item'),
  }
}
</script>